import { connect } from "react-redux";
import StudentResourcesPanel from "./StudentResourcesPanel";
import { fetchCourseResources } from "../../actions/course_resources_actions";

const uniq = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

const getEnrollmentCourseKey = (enr) => {
  if (!enr) return "";
  return (
    enr?.course?.key ||
    enr?.course?.courseKey ||
    enr?.courseKey ||
    enr?.key ||
    ""
  );
};

const mapStateToProps = (state) => {
  const slice = state.courseResources || {};
  const byId = slice.byId || {};
  const byCourseKey = slice.byCourseKey || {};

  // enrolled course keys
  const enrById = state.enrollments?.byId || {};
  const enrIds = state.enrollments?.allIds || [];
  const enrolledCourseKeys = uniq(enrIds.map((id) => getEnrollmentCourseKey(enrById[id])));

  // map courseKey -> resources[]
  const resourcesByCourseKey = {};
  enrolledCourseKeys.forEach((k) => {
    const ids = byCourseKey[k] || [];
    resourcesByCourseKey[k] = ids.map((id) => byId[id]).filter(Boolean);
  });

  return {
    enrolledCourseKeys,
    resourcesByCourseKey,
    isLoading: !!slice.isLoading,
    error: slice.error || "",
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCourseResources: (params) => dispatch(fetchCourseResources(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentResourcesPanel);
